export type VersionCheckFailureKind = 'transient-network' | 'server'

/**
 * Distinguishes client-side network blips from endpoint/deploy failures.
 *
 * Version polling runs every 5 minutes plus focus/online triggers. Reporting
 * every browser "Failed to fetch" to Sentry creates noise during live events
 * when connectivity drops for a few seconds (EVNTTZ-16R).
 */
export const classifyVersionCheckError = (
  error: Error
): VersionCheckFailureKind => {
  if (error.name === 'AbortError') return 'transient-network'

  if (
    error instanceof TypeError &&
    (error.message === 'Failed to fetch' ||
      error.message.includes('NetworkError'))
  )
    return 'transient-network'

  if (error.message === 'Failed to fetch') return 'transient-network'

  return 'server'
}

export const isTransientVersionCheckError = (error: Error) =>
  classifyVersionCheckError(error) === 'transient-network'
